import { defaultConfig } from '@chakra-ui/react';

export const fontsTheme = {
  fontWeights: {
    light: { value: 300 }, // Deprecated in modern theme
    normal: { value: 400 },
    medium: { value: 500 }, // Deprecated in modern theme
    semibold: { value: 600 },
    bold: { value: 700 }, // Deprecated in modern theme
  },
  fonts: {
    ...defaultConfig.theme?.tokens?.fonts,
    body: { value: 'Inter, sans-serif' },
    heading: { value: 'Inter, sans-serif' },
  },
  fontSizes: {
    '2xs': { value: '0.5rem' },
    xs: { value: '0.625rem' }, // Smallest text size in modern theme
    sm: { value: '0.75rem' }, // Heading xs size, regular text size in modern theme
    md: { value: '0.875rem' }, // Heading sm size
    lg: { value: '1rem' },
    xl: { value: '1.125rem' }, // Heading md size
    '2xl': { value: '1.25rem' },
    '3xl': { value: '1.5rem' }, // Largest size for non-headings in modern theme, heading lg size
    '4xl': { value: '1.875rem' }, // Heading xl size
    '5xl': { value: '2.25rem' }, // Largest text size in modern theme, heading 2xl size
    '6xl': { value: '3rem' }, // Deprecated in modern theme
    '7xl': { value: '3.75rem' }, // Deprecated in modern theme
    '8xl': { value: '4.5rem' }, // Deprecated in modern theme
    '9xl': { value: '6rem' }, // Deprecated in modern theme
  },
};
